export const isRentalsV2Path = () => {
  const rentalsV2Regex =
    /^\/orders\/rentals\/v2\/[A-Za-z0-9]+\/(edit|reorder)$/;

  return (
    rentalsV2Regex.test(window.location.pathname) ||
    window.location.pathname === '/orders/rentals/v2/new'
  );
};

export const isRentalCreationOrEditPath = (pathname: string) => {
  if (!pathname) return false;

  return (
    pathname.includes('/orders/rentals/v2/new') ||
    pathname.includes('/orders/rentals/new') ||
    (pathname.includes('/orders/rentals') && pathname.includes('/edit')) ||
    (pathname.includes('/orders/rentals/v2/') && pathname.includes('/reorder'))
  );
};
